import get from 'lodash/get';

export default function areGdprObligationsComplete(state) {
  const { gdprApplies, hasConsentBeenCaptured } = get(
    state,
    'app.oneTrust.gdpr',
    {},
  );
  return hasConsentBeenCaptured || gdprApplies === false;
}
